import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { LandingPage } from "components/common/LandingPage";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { CarLeasingRoutes } from "./CarLeasingRoutes";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class CarLeasingContainer extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    async componentDidMount() {
        pushRoute(CarLeasingRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("carLeasing.document.title"),
            });

        } catch (error) {
            debug.log("### CarLeasingContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    render() {
        document.title = ui.__("carLeasing.document.title");
        return (
            <div>
                <Route
                    exact
                    path={CarLeasingRoutes.ROOT}
                    render={() =>
                        <LandingPage
                            useWebVersion
                            type="PRODUCT"
                            code="CAR_LEASING"
                        />
                    }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/carLeasing/CarLeasingContainer.tsx